import { ConcreteEncodable } from "./ConcreteEncodable";

import { ServiceRequestErrorEncoder } from "../../encoder/ServiceRequestErrorEncoder";

import * as CubiqTS from "../../index";

export class ServiceRequestError extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.broker.ServiceRequestError";

  /*FID=1*/
  public errorList: CubiqTS.Errors | null = null;
  /*FID=2*/
  public payload: CubiqTS.Encodable | null = null;
  /*FID=3*/
  public requestId: string;
  /*FID=4*/
  public responseCode: CubiqTS.ResponseCode;
  /*FID=5*/
  public serviceRequestType: string;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = ServiceRequestErrorEncoder.Instance;
    this.setEncodableType(ServiceRequestError.enType);
    //Model
  }

  public toString(): string {
    return (
      "ServiceRequestError[" +
      "errorList=" +
      this.errorList +
      "payload=" +
      this.payload +
      "requestId=" +
      this.requestId +
      "responseCode=" +
      this.responseCode +
      "serviceRequestType=" +
      this.serviceRequestType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
